import ChangeSignInMethodOptionsComponent from './ChangeSignInMethodOptionsContainer';

export default ChangeSignInMethodOptionsComponent;